import React from "react";
import {
  Modal,
  Platform,
  Pressable,
  ScrollView,
  StyleSheet,
  Text,
  View,
  useWindowDimensions,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

type Props = {
  visible: boolean;
  shortDescription: string;
  onClose: () => void;
};

export default function AboutUsPopup({
  visible,
  shortDescription,
  onClose,
}: Props) {
  const { width } = useWindowDimensions();
  const insets = useSafeAreaInsets();
  const useCenteredModal = Platform.OS === "web" && width >= 1024;

  return (
    <Modal
      visible={visible}
      transparent
      animationType={useCenteredModal ? "fade" : "slide"}
      onRequestClose={onClose}
      statusBarTranslucent
    >
      <View
        style={[
          styles.overlay,
          useCenteredModal ? styles.overlayCentered : styles.overlaySheet,
        ]}
      >
        <Pressable
          accessibilityLabel="Close About Us"
          onPress={onClose}
          style={StyleSheet.absoluteFillObject}
        />

        <View
          accessibilityViewIsModal
          style={[
            styles.surface,
            useCenteredModal
              ? styles.centerSurface
              : [
                  styles.sheetSurface,
                  { paddingBottom: Math.max(insets.bottom, 18) },
                ],
          ]}
        >
          {!useCenteredModal ? <View style={styles.sheetHandle} /> : null}

          <ScrollView
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.content}
          >
            <Text style={styles.description}>{shortDescription}</Text>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(15,23,42,0.38)",
    padding: 16,
  },

  overlayCentered: {
    alignItems: "center",
    justifyContent: "center",
  },

  overlaySheet: {
    justifyContent: "flex-end",
  },

  surface: {
    backgroundColor: "#ffffff",
    shadowColor: "#000000",
    shadowOpacity: 0.18,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 8 },
    elevation: 8,
  },

  centerSurface: {
    width: "100%",
    maxWidth: 520,
    maxHeight: "70%",
    borderRadius: 18,
    padding: 22,
  },

  sheetSurface: {
    width: "100%",
    maxHeight: "72%",
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    paddingHorizontal: 20,
    paddingTop: 10,
  },

  sheetHandle: {
    alignSelf: "center",
    width: 42,
    height: 4,
    borderRadius: 999,
    backgroundColor: "#cbd5e1",
    marginBottom: 14,
  },

  content: {
    paddingBottom: 2,
  },

  description: {
    fontSize: 15,
    lineHeight: 23,
    fontWeight: "700",
    color: "#111827",
  },
});
